import React, { Component } from "react";

import "./FolderDetailsView.scss";
import dateFormat from "dateformat";
import ActivityTab from "./ActivityTab/ActivityTab";
import SharedWithTab from "./SharedWithTab/SharedWithTab";
import CloseIcon from "../../assets/icons/close.svg";
import folderColor1 from "../../assets/icons/folder_color-1.svg";
import folderColor2 from "../../assets/icons/folder_color-2.svg";
import folderColor3 from "../../assets/icons/folder_color-3.svg";
import folderColor4 from "../../assets/icons/folder_color-4.svg";
import folderColor5 from "../../assets/icons/folder_color-5.svg";
import folderColor6 from "../../assets/icons/folder_color-6.svg";
import folderColorPrimary from "../../assets/icons/folder_primary.svg";
import { getName } from "../../helper";

const colors = {
  1: folderColor1,
  2: folderColor2,
  3: folderColor3,
  4: folderColor4,
  5: folderColor5,
  6: folderColor6,
  7: folderColorPrimary,
};

class FolderDetailsView extends Component {
  state = {
    isVisible: true,
  };

  activityToggle = () => {
    this.setState({ isVisible: true });
  };

  sharedWithToggle = () => {
    this.setState({ isVisible: false });
  };

  render() {
    return (
      <div className="row">
        <div className="col-md ml-6">
          <div className="row">
            <div className="col-md d-flex details-header">
              <h4 className="pl-2" style={{ alignSelf: "center" }}>
                Details
              </h4>
              <img
                className="close mr-6 ml-auto"
                width="24"
                height="24"
                src={CloseIcon}
                alt="closeIcon"
                onClick={this.props.dockHandler}
                style={{ alignSelf: "center" }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md mt-6">
              <div className="d-flex">
                <img
                  className="pr-2"
                  src={
                    colors[
                      parseInt(this.props.folderDetails.color.id) || "primary"
                    ]
                  }
                  alt="Folder Primary"
                />
                <h6 style={{ alignSelf: "center" }}>
                  <strong>{this.props.folderDetails.title}</strong>
                </h6>
              </div>
              <div className="pt-2">
                <p>{this.props.folderDetails.description}</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mt-3">
              <label>Created By</label>
            </div>
            <div className="col-md-6 mt-3">
              <h6>{getName(this.props.folderDetails.createdBy)}</h6>
            </div>
            <div className="col-md-6 mt-3">
              <label>Created On</label>
            </div>
            <div className="col-md-6 mt-3">
              <h6>
                {dateFormat(this.props.folderDetails.createdTs, "mmm dd, yyyy")}
              </h6>
            </div>
            <div className="col-md-6 mt-3">
              <label>
                {this.props.folderDetails.parentFolder
                  ? "Number of Files"
                  : "Number of Sub-folders"}
              </label>
            </div>
            <div className="col-md-6 mt-3">
              <h6>{this.props.itemsCount}</h6>
            </div>
          </div>
          <div className="row folder-details">
            <div className="col-md mr-6 mt-6 mb-12">
              <div className="d-md-flex tabs-header">
                <div
                  className={[
                    "tab-title p-1 mx-9",
                    this.state.isVisible ? "active" : "",
                  ].join(" ")}
                  onClick={this.activityToggle}
                >
                  Activity Logs
                </div>

                <div
                  className={[
                    "tab-title p-1",
                    this.state.isVisible ? "" : "active",
                  ].join(" ")}
                  onClick={this.sharedWithToggle}
                >
                  Shared With
                </div>
              </div>
              {this.state.isVisible ? (
                <ActivityTab {...this.props} />
              ) : (
                <SharedWithTab {...this.props} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default FolderDetailsView;
